import IndexInfo from '../../../common/index-info'

export default IndexInfo
